import { isTabbable } from 'tabbable';
/**
 * trigger focus on a DOM element (set negative tabindex if needed)
 */
const focusElement = (element, focusOptions) => {
    var _a;
    if (typeof (element === null || element === void 0 ? void 0 : element.focus) === 'function' && ((_a = element.ownerDocument) === null || _a === void 0 ? void 0 : _a.activeElement) !== element) {
        // ensure element is focusable if not natively focusable
        if (!isTabbable(element)) {
            element.setAttribute('tabindex', '-1');
        }
        element.focus(focusOptions);
        return true;
    }
    return false;
};
export default focusElement;
//# sourceMappingURL=focusElement.js.map